import OrderProvider from '@/resources/order.service'

const orderService = new OrderProvider()

const state = {
  items: [],
  shippingPrice: 0,
  discount: {
    type: 'บาท',
    number: 0
  },
  shipping: {
    customerName: '',
    customerEmail: '',
    customerTel: '',
    customerAddress: '',
    customerSubDistrict: '',
    customerDistrictCity: '',
    customerStateProvince: '',
    customerCountry: '',
    customerPostcode: ''
  },
  isEditBill: false,
  editingBill: {},
  bill: {}
}
function calDiscount (state) {
  switch (state.discount.type) {
    case 'บาท':
      return state.discount.number
    case '%':
      return (state.items.reduce((sum, item) => sum + parseFloat(item.price), 0)
                * (state.discount.number / 100))
    default:
      return 0
  }
}
const calNet = (state) => {
  const sumPrice = state.items.reduce((sum, item) => sum + parseFloat(item.price), 0)
  const net = sumPrice + state.shippingPrice - calDiscount(state)
  return net >= 0 ? net : 0
}
const mapOrder = (state, warehouse) => {
  const skus = state.items.map((item) => ({
    id: `${item.id}`,
    price: parseFloat(item.price),
    // eslint-disable-next-line radix
    amount: parseInt(item.amount),
    name: item.name,
    code: item.code,
    option1: item.option1 ? item.option1 : '',
    option2: item.option2 ? item.option2 : '',
    option3: item.option3 ? item.option3 : '',
    warehouse: item.warehouse
  }))
  const order = {
    skus,
    customerName: state.shipping.customerName,
    customerEmail: state.shipping.customerEmail,
    customerTel: state.shipping.customerTel,
    customerAddress: state.shipping.customerAddress,
    customerSubDistrict: state.shipping.customerSubDistrict,
    customerDistrictCity: state.shipping.customerDistrictCity,
    customerStateProvince: state.shipping.customerStateProvince,
    customerCountry: state.shipping.customerCountry,
    customerPostcode: state.shipping.customerPostcode,
    shippingType: 'ems',
    discount: calDiscount(state),
    shippingPrice: state.shippingPrice,
    dayExpire: 7,
    note: '',
    sellsukiWarehouse: warehouse,
    debts: [{
      payOrder: 1,
      debtBalance: calNet(state)
    }]
  }
  return order
}

const actions = {
  addItem ({ commit }, payload) {
    commit('PUSH_ITEM', payload)
  },
  removeItem ({ commit }, skuId) {
    commit('REMOVE_ITEM', skuId)
  },
  clearItems ({ commit }) {
    commit('CLEAR_ITEM')
  },
  setShipping ({ commit }, payload) {
    commit('SET_SHIPPING', payload)
  },
  setDiscount ({ commit }, discount) {
    commit('SET_DISCOUNT', discount)
  },
  setShippingPrice ({ commit }, shippingPrice) {
    commit('SET_SHIPPING_PRICE', shippingPrice)
  },
  clearCart ({ commit }) {
    commit('CLEAR_CART')
    commit('SET_IS_EDIT_BILL', false)
  },
  prepareUpdateOder ({ commit }, payload) {
    commit('SET_IS_EDIT_BILL', true)
    commit('SET_EDITING_BILL', payload.bill)
    commit('SET_ITEM', payload.items)
    commit('SET_DISCOUNT', payload.discount)
    commit('SET_SHIPPING_PRICE', payload.shippingPrice)
    commit('SET_SHIPPING', payload.shipping)
  },
  async createOrder ({ state, commit }, warehouse) {
    const payload = mapOrder(state, warehouse)
    try {
      const { data } = await orderService.createOrder(payload)
      commit('CLEAR_CART')
      commit('SET_BILL', data)
      return { success: true }
    } catch (err) {
      return { success: false, message: err.message }
    }
  },
  async updateOrder ({ state, commit }, warehouse) {
    const payload = mapOrder(state, warehouse)
    try {
      const { data } = await orderService.updateOrder(state.editingBill.id, payload)
      commit('CLEAR_CART')
      commit('SET_IS_EDIT_BILL', false)
      commit('SET_BILL', data)
      return { success: true }
    } catch (err) {
      return { success: false, message: err.message }
    }
  }
}

const mutations = {
  SET_SHIPPING (state, payload) {
    state.shipping = payload
  },
  SET_IS_EDIT_BILL (state, payload) {
    state.isEditBill = payload
  },
  SET_EDITING_BILL (state, payload) {
    state.editingBill = payload
  },
  CLEAR_CART (state) {
    state.items = []
    state.shippingPrice = 0
    state.discount = {
      type: 'บาท',
      number: 0
    }
    state.shipping = {
      customerName: '',
      customerEmail: '',
      customerTel: '',
      customerAddress: '',
      customerSubDistrict: '',
      customerDistrictCity: '',
      customerStateProvince: '',
      customerCountry: '',
      customerPostcode: ''
    }
  },
  SET_BILL (state, payload) {
    state.bill = payload
  },
  SET_SHIPPING_PRICE (state, payload) {
    state.shippingPrice = payload
  },
  PUSH_ITEM (state, payload) {
    state.items.push(payload)
  },
  SET_ITEM (state, payload) {
    state.items = payload
  },
  SET_DISCOUNT (state, payload) {
    state.discount.type = payload.type
    state.discount.number = payload.number
  },
  CLEAR_ITEM (state) {
    state.items = []
  },
  REMOVE_ITEM (state, skuId) {
    const index = state.items.findIndex((item) => item.id === skuId)
    if (index !== -1) {
      state.items.splice(index, 1)
    }
  }
}

const getters = {
  discount: (state) => state.discount,
  shipping: (state) => state.shipping,
  shippingPrice: (state) => state.shippingPrice,
  items: (state) => state.items,
  amountItem: (state) => state.items.length,
  sumItemPrice: (state) => state.items.reduce((sum, item) => sum + parseFloat(item.price), 0),
  discountPrice: (state) => calDiscount(state),
  net: (state) => calNet(state),
  bill: (state) => state.bill,
  isEditBill: (state) => state.isEditBill,
  editingBill: (state) => state.editingBill
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
